import React from 'react';

const Button = (props) => {
    const {
        label,
        icon = null,
        type = null,
        href = null,
        classes = null,
        onClick = null,
        disabled = false,
        target = null,
        style = null
    } = props;

    let iconItem = null;
    if (!!icon) {
        iconItem = (
            <i className={icon + " mr-2"} />
        )
    }

    if (!!onClick) {
        return (
            <button style={style} disabled={disabled} onClick={(event) => {
                event.preventDefault();
                onClick();
            }} className={"btn font-weight-bold px-3 " + classes}>
                {iconItem}
                <span>{label}</span>
            </button>
        )
    } else if (!!type) {
        return (
            <button style={style} disabled={disabled} type={type} className={"btn font-weight-bold px-3 " + classes}>
                {iconItem}
                <span>{label}</span>
            </button>
        )
    } else if (!!href) {
        return (
            <a href={href}
                style={style}
                className={"btn font-weight-bold " + classes + (disabled ? " disabled" : "")}
                target={!!target ? target : ""}
            >
                {iconItem}
                <span>{label}</span>
            </a>
        );
    } else {
        return null;
    }
}

export default Button;
